<template>
  <base-app-bar
    :login-location="
      $zvdzRoute.meta && $zvdzRoute.meta.mustBeLoggedIn
        ? {
            name: RouteName.LoginIndex,
            query: { ReturnUrl: $zvdzRoute.fullPath },
          }
        : undefined
    "
    :show-side-menu="false"
  />
</template>

<script lang="ts" setup>
import BaseAppBar from './BaseAppBar.vue';
</script>
